// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"653cedfe","609":"c9c27c84"}[chunkId] + ".chunk.js";
};